const PRODUCT_DISPLAY_NAMES = {
  SphereAuralizer: "Auralizer (Legacy)",
  "Auralizer-v2": "Auralizer",
  SpatializationPlugins: "Controller/Renderer",
  Autocheck: "Autocheck",
};

export function getProductDisplayName(name) {
    return PRODUCT_DISPLAY_NAMES[name] ?? name;
}
